<a alt="Print" (click)="handlePrintClick()" class="btn active">
  <i class="fa fa-print fa-lg"></i>
</a>

<div class="hidden">
  <ng-container *ngIf="isPrinting$ | async">
    <ng-container *ngTemplateOutlet="printTemplate;"></ng-container>
  </ng-container>
</div>